export function mostraZeroDec(decimals) {
  if (!decimals) {
    return;
  }
  return decimals.toFixed(1);
}
